import React from 'react';
import { MasterLayout } from 'layout';
import { TongHopKetQua } from 'modules/thong-ke-bao-cao';

class TongHopKetQuaThanhTraPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='TONG_HOP_KET_QUA_THANH_TRA' />
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaThanhTraPage;



// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaThanhTra.jsx